module.exports = __webpack_public_path__ + "img/mi_switch.f4eb0960.svg";